import { ProjectRuntimes } from '../types/runtimes';

export const isJestRuntime =
    process.env.REACT_APP_RUNTIME === ProjectRuntimes.JEST;

export const isDev = process.env.NODE_ENV === 'development';

const getSentryEnvironment = (): string =>
    (process.env.REACT_APP_SENTRY_ENV ?? '').toLowerCase();

/** Version label is off by default; enabled only on development, qa, local, or unset env. */
export const shouldShowVersionInfo = (): boolean => {
    const sentryEnvironment = getSentryEnvironment();

    if (sentryEnvironment === '') {
        return true;
    }

    const enabledEnvironments = new Set(['development', 'qa', 'local']);
    return enabledEnvironments.has(sentryEnvironment);
};

const searchVersionDebugEnvironmentsForReOpsUsers = new Set([
    'demo',
    'live',
    'production',
]);

/** Search version debug controls are shown in lower envs for all users, or in demo/live/production for @re-ops.co users. */
export const shouldShowSearchVersionDebug = (isReOpsUser: boolean): boolean => {
    if (shouldShowVersionInfo()) {
        return true;
    }

    const sentryEnvironment = getSentryEnvironment();

    return (
        searchVersionDebugEnvironmentsForReOpsUsers.has(sentryEnvironment) &&
        isReOpsUser
    );
};
